import { toast } from "react-hot-toast";
import axiosInstance from "./apiinterseptor";

export const getHunarFunnelRecords = async (params: Record<string, string | number | undefined> = {}) => {
  try {
    const response = await axiosInstance.get("/hunar-funnel", { params });
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to fetch Hunar funnel records");
    throw error;
  }
};

export const getHunarFunnelWhatsapp = async (recordId: string) => {
  try {
    const response = await axiosInstance.get(`/hunar-funnel/${recordId}/whatsapp`);
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to load WhatsApp messages");
    throw error;
  }
};

export const getHunarFunnelRecord = async (recordId: string) => {
  try {
    const response = await axiosInstance.get(`/hunar-funnel/${recordId}`);
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to fetch Hunar funnel record");
    throw error;
  }
};

export const ingestHunarFunnelApiRecord = async (payload: Record<string, unknown>) => {
  try {
    const response = await axiosInstance.post("/hunar-funnel/ingest", payload);
    toast.success("Hunar funnel record created");
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to create Hunar funnel record");
    throw error;
  }
};

export const updateFunnelNote = async (recordId: string, note: string | null) => {
  try {
    const response = await axiosInstance.patch(`/hunar-funnel/${recordId}/note`, { note });
    toast.success("Note saved");
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to save note");
    throw error;
  }
};

export const updateFunnelManualStatus = async (
  recordId: string,
  manualStatus: string | null,
  manualStatusReason: string | null
) => {
  try {
    const response = await axiosInstance.patch(`/hunar-funnel/${recordId}/manual-status`, {
      manualStatus,
      manualStatusReason,
    });
    toast.success("Status updated");
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to update status");
    throw error;
  }
};

export const retriggerHunarCancelledCalls = async () => {
  try {
    const response = await axiosInstance.post("/hunar-funnel/retrigger-cancelled");
    toast.success(response?.data?.message || "Hunar cancelled retrigger queued");
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to retrigger Hunar-cancelled calls");
    throw error;
  }
};

export const ingestConfiguredHunarSheet = async () => {
  try {
    const response = await axiosInstance.post("/hunar-funnel/ingest-sheet");
    toast.success("Configured Hunar sheet ingested");
    return response.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to ingest configured sheet");
    throw error;
  }
};
